import {useAuth} from "base/auth";

export function useConcelloAuth() {
    const {user, hasRole, ROLES} = useAuth();

    const checkAllowed = codigoConcello => {
        if (hasRole(ROLES.CONCELLO) && user.codigo_concello && codigoConcello) {
            return user.codigo_concello === parseInt(codigoConcello);
        }
        if (hasRole(ROLES.SUPRAMUNICIPAL) && user.concellos && codigoConcello) {
            return user.concellos.includes(parseInt(codigoConcello));
        }
        return true;
    };

    const isConcelloUser = () => {
        return hasRole(ROLES.CONCELLO);
    };

    const isSupramunicipalUser = () => {
        return hasRole(ROLES.SUPRAMUNICIPAL);
    };

    return {checkAllowed, isConcelloUser, isSupramunicipalUser};
}

